import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateBancoForm } from '../Validations/ValidationsBanco';

export default function AddBancoForm() {
  const [formData, setFormData] = useState({
    documentoTercero: '',
    descripcion: '',
    nombreBanco: '',
    iban: ''
  });
  const [errors, setErrors] = useState({});
  const [terceros, setTerceros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTerceros();
  }, []);

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      console.error('Error fetching terceros:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateBancoForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/bancos', formData);
        navigate('/home/bancos');
      } catch (err) {
        console.error('Error saving banco:', err);
        setErrors({ submit: 'Error al guardar el banco. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Banco</h2>
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="documentoTercero">
            Documento del Tercero
          </label>
          <select
            name="documentoTercero"
            value={formData.documentoTercero}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.documentoTercero ? 'border-red-500' : ''}`}
          >
            <option value="">Seleccione un tercero</option>
            {terceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
          {errors.documentoTercero && <p className="text-red-500 text-xs italic">{errors.documentoTercero}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="descripcion">
            Descripción
          </label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.descripcion ? 'border-red-500' : ''}`}
            placeholder="Descripción (opcional)"
          />
          {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nombreBanco">
            Nombre del Banco
          </label>
          <input
            type="text"
            name="nombreBanco"
            value={formData.nombreBanco}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.nombreBanco ? 'border-red-500' : ''}`}
            placeholder="Nombre del Banco"
          />
          {errors.nombreBanco && <p className="text-red-500 text-xs italic">{errors.nombreBanco}</p>}
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="iban">
            IBAN
          </label>
          <input
            type="text"
            name="iban"
            value={formData.iban}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.iban ? 'border-red-500' : ''}`}
            placeholder="IBAN"
          />
          {errors.iban && <p className="text-red-500 text-xs italic">{errors.iban}</p>}
        </div>
        {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Banco'}
          </button>
        </div>
      </form>
    </div>
  );
}
